/* eslint-disable no-case-declarations, no-param-reassign */
import _ from 'lodash';
import * as types from '../action.types';

export const initialState = {

};

const SessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_SESSIONS_SUCCESS:
      return _.reduce(action.payload, (result, session) => {
        result[session.id] = {
          id: session.id,
          name: session.name,
          createdAt: session.createdAt,
          lastModified: session.lastModified,
          hide: session.hide,
          files: _.mapKeys(session.files, 'id'),
        };

        return result;
      }, { ...state });

    case types.DELETE_SESSION_SUCCESS:
      return _.omit(state, action.payload);

    case types.DELETE_SESSION_FILE_SUCCESS:
      const newState = {
        ...state,
        [action.payload.sessionId]: {
          ...state[action.payload.sessionId],
          files: _.omit(state[action.payload.sessionId].files, action.payload.fileId),
        },
      };

      return _.size(newState[action.payload.sessionId].files) > 0
        ? newState
        : _.omit(state, action.payload.sessionId);

    case types.FETCH_SESSION_FILES_SUCCESS:
      return {
        ...state,
        [action.payload.sessionId]: {
          ...state[action.payload.sessionId],
          id: action.payload.sessionId,
          files: _.mapKeys(action.payload.files, 'id'),
        },
      };

    case types.UPDATE_SESSION_NAME_SUCCESS:
      return {
        ...state,
        [action.payload.sessionId]: {
          ...state[action.payload.sessionId],
          name: action.payload.name,
        },
      };

    case types.UPDATE_SESSION_HIDE_SUCCESS:
      return {
        ...state,
        [action.payload.sessionId]: {
          ...state[action.payload.sessionId],
          hide: action.payload.hide,
        },
      };
    case types.UPDATE_FILE_ACTIVE_SUCCESS:
      return {
        ...state,
        [action.payload.sessionId]: {
          ...state[action.payload.sessionId],
          files: {
            ...state[action.payload.sessionId].files,
            [action.payload.fileId]: {
              ...state[action.payload.sessionId].files[action.payload.fileId],
              active: action.payload.active,
            },
          },
        },
      };
    case types.UPDATE_FILE_FILENAME_SUCCESS:
      return {
        ...state,
        [action.payload.sessionId]: {
          ...state[action.payload.sessionId],
          files: {
            ...state[action.payload.sessionId].files,
            [action.payload.fileId]: {
              ...state[action.payload.sessionId].files[action.payload.fileId],
              displayname: action.payload.filename,
            },
          },
        },
      };
    case types.UPDATE_FILE_RULES_APPLIED:
      return {
        ...state,
        [action.payload.sessionId]: {
          ...state[action.payload.sessionId],
          files: {
            ...state[action.payload.sessionId].files,
            [action.payload.fileId]: {
              ...state[action.payload.sessionId].files[action.payload.fileId],
              rulesApplied: action.payload.rulesApplied,
            },
          },
        },
      };
    case types.UPDATE_FILE_SKIPPED_COLUMNS_HIDDEN:
      return {
        ...state,
        [action.payload.sessionId]: {
          ...state[action.payload.sessionId],
          files: {
            ...state[action.payload.sessionId].files,
            [action.payload.fileId]: {
              ...state[action.payload.sessionId].files[action.payload.fileId],
              skippedColumnsHidden: action.payload.skippedColumnsHidden,
            },
          },
        },
      };
    case types.UPDATE_FILE_NOTES_EDITOR_CONTENT:
      return {
        ...state,
        [action.payload.sessionId]: {
          ...state[action.payload.sessionId],
          files: {
            ...state[action.payload.sessionId].files,
            [action.payload.fileId]: {
              ...state[action.payload.sessionId].files[action.payload.fileId],
              notesEditorContent: action.payload.notesEditorContent,
            },
          },
        },
      };
    default:
      return state;
  }
};

export default SessionReducer;
